.event-calendar-content {
  display: flex;
  position: relative;
  flex: 1;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.event-calendar-body {
  position: relative;
  flex: 1;
  height: 100%;
  min-height: 0;
  overflow: auto;
}
